import { useMemo } from "react";
import { AxiosError, AxiosInstance } from "axios";
import { API_BASE_URL } from "/src/constants";
import AuthProvider from "/src/components/AuthProvider";
import { httpServiceFactory } from "/src/utils/http";

interface UseHttpClientOptions {
  baseURL?: string;
}

interface AuthUser {
  token: string;
  [key: string]: any;
}

function useHttpClient({ baseURL }: UseHttpClientOptions = {}): AxiosInstance {
  const { logout } = AuthProvider.useAuth() as {
    user: AuthUser | null;
    logout: () => void;
  };
  const service = useMemo(
    () => {
      const instance = httpServiceFactory({
        getAuthorizationFn: () => {
          const user = AuthProvider.getUser();
          return (user ? `Bearer ${user.token}` : "")
        },
        baseUrl: baseURL || API_BASE_URL,
        getUrlParamsFn: () => ({}),
      });
      instance.interceptors.response.use(
        (res) => res,
        (e: AxiosError) => {
          const { response } = e;
          const currentUser = AuthProvider.getUser();
          const requestAuthorization = response?.config.headers.get("Authorization");
          if (
            response?.status === 401 &&
            !baseURL &&
            currentUser &&
            requestAuthorization === `Bearer ${currentUser.token}`
          ) {
            logout();
          }
          return Promise.reject(e);
        }
      );
      return instance;
    },
    [baseURL]
  );

  return service;
}

export default useHttpClient;
